/* app/js/src/components/mediaEditor/backButton/backButton.component.scss */
.cursor-pointer {
  cursor: pointer;
}
a {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}
a > div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 28px;
  width: 28px;
  border-radius: 4px;
  margin-right: 12px;
}
a > div.bg-white {
  background-color: #ffffff;
}
a > div.bg-pale-white {
  background-color: #f1f3f4;
}
a > div svg {
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  -ms-transform: translateX(0);
  -webkit-transform: translateX(0);
  transform: translateX(0);
}
a > span {
  color: #879baf;
  font-size: 0.7em;
  text-decoration: none;
  text-transform: uppercase;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
a:hover {
  text-decoration: none;
}
a:hover > span {
  color: #232f3a;
}
a:hover > div svg {
  -ms-transform: translateX(-1px);
  -webkit-transform: translateX(-1px);
  transform: translateX(-1px);
}
/*# sourceMappingURL=backButton.component.css.map */
